import { setLocale } from '../utils/localemanager.utils';

export default () => {
  (window as any).Mpro = Object.assign({}, (window as any).Mpro, {

    // Assigns to the window object a LocaleManager and used by
    // apps/mpro5/web/client/RazorComponents/LocaleManager/LocaleManager.razor.ts to set locale
    LocaleManager: { setLocale }
  });
}
